<template>
    <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M9.00006 3.48755C5.41506 3.48755 2.49756 6.40505 2.49756 9.99005C2.49756 13.575 5.41506 16.5 9.00006 16.5C12.5851 16.5 15.5026 13.5825 15.5026 9.99755C15.5026 6.41255 12.5851 3.48755 9.00006 3.48755ZM9.56256 9.75005C9.56256 10.0575 9.30756 10.3125 9.00006 10.3125C8.69256 10.3125 8.43756 10.0575 8.43756 9.75005V6.00005C8.43756 5.69255 8.69256 5.43755 9.00006 5.43755C9.30756 5.43755 9.56256 5.69255 9.56256 6.00005V9.75005Z"
            fill="#48E4FF"
        />
        <path
            d="M11.168 2.58774H6.83297C6.53297 2.58774 6.29297 2.34774 6.29297 2.04774C6.29297 1.74774 6.53297 1.50024 6.83297 1.50024H11.168C11.468 1.50024 11.708 1.74024 11.708 2.04024C11.708 2.34024 11.468 2.58774 11.168 2.58774Z"
            fill="#48E4FF"
        />
    </svg>
</template>

<script>
export default {
    data() {
        return {};
    },
};
</script>
